import React, { useMemo, useState } from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';

import Spinner from 'components/Spinner/mobile';
import Paginator from 'components/Paginator';
import SVG from 'components/SVG';
import useModel from 'features/slotsHistory/model/useModel';
// import { useAppSelector } from 'shared/hooks';

import SlotsHistoryItem from './SlotsHistoryItem';
import SlotsHistoryFilter from './SlotsHistoryFilter';

// import filterSVG from './img/filter.svg';
// import arrowSVG from './img/arrow.svg';

import { ISlotsHistoryProps } from './types';
import './SlotsHistory.scss';

const b = block('slots-history-mobile');

const SlotsHistory = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { actionProcessing } = useSelector(state => state.slotsHistory, shallowEqual);

  const [isFiltersOpened, setIsFilterOpened] = useState(false);

  const model = useModel();

  const itemsElements = useMemo(
    () =>
      model.outputState.items.map((t, i) => (
        <div key={`${i}_${t.amount}_${t.date}_${t.provider}_${t.status}`} className={b('item')}>
          <SlotsHistoryItem item={t} userId={model.inputState.values.userId} />
        </div>
      )),
    [model.outputState.items, model.inputState.values.userId],
  );

  return (
    <>
      <Spinner isLoading={actionProcessing} />
      <div className={b()}>
        <div className={b('title')}>{locale.betHistory}</div>
        {/* {isFiltersOpened && ( */}
        <SlotsHistoryFilter
          filterState={model.inputState}
          warning={model.outputState.warning}
          onClose={() => setIsFilterOpened(false)}
        />
        {/* )} */}
        <div className={b('content')}>
          <div className={b('list')}>{itemsElements}</div>
          {model.outputState.pageCount > 1 && (
            <div className={b('paginator')}>
              <Paginator
                count={model.outputState.pageCount}
                currentPage={model.inputState.values.page}
                onPageClick={model.inputState.onPageChanged}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SlotsHistory;
